import React, { useEffect, useState } from 'react'
import Select from 'react-select'

export const EVENT_STATUS_CLOSE = '0'
export const EVENT_STATUS_OPEN = '1'

const options = [
  { value: EVENT_STATUS_CLOSE, label: 'Closed' },
  { value: EVENT_STATUS_OPEN, label: 'Open' },
]

function SelectEventStatus({ onChangeEventStatus, eventStatus, isDisabled = false }) {
  const [state, setState] = useState({
    selectedOption: [],
  })

  useEffect(() => {
    setState({
      ...state,
      selectedOption: eventStatus,
    })
  }, [eventStatus])

  const handleChange = (selectedOption) => {
    setState({ selectedOption })
    onChangeEventStatus({ selectedOption })
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: '300px',
      maxWidth: '400px',
      fontSize: '14px',
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
  }

  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      value={eventStatus}
      onChange={handleChange}
      options={options}
      placeholder='Event Status'
      className='rounded-0 ms-3 text-orange payment-status'
      isDisabled={isDisabled}
      styles={customStyles}
    />
  )
}

export default SelectEventStatus
